export default {"src":"/_next/static/media/close.b410993d.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};